import { ElLoading } from "element-plus";

export interface ThrobberMixin {
  showThrobber(text?: string): void;
  hideThrobber(): void;
}

export const throbberMixins: ThrobberMixin = {
  showThrobber(text?: string) {
    ElLoading.service({
      lock: true,
      text: text ?? "Загрузка...",
      customClass: "disable-select",
    });
  },
  hideThrobber() {
    ElLoading.service().close();
  },
};

export default {
  methods: throbberMixins,
};
